import * as z from "zod/v4";

export const getMetaAdsOAuthURL = {
  name: "getMetaAdsOAuthURL" as const,
  input: z.null(),
  output: z.object({ url: z.string() }),
};
